import { Fragment, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPrecio } from '../../actions/precios'
import '../../css/Precio.css'
import i18n from '../../lang/idiomas'
import Spinner from '../layout/Spinner'

const Precio = props => {
  const dispatch = useDispatch()

  const portal = useSelector(state => state.portal.portal)
  const precio = useSelector(state => state.precios.precio)
  const decimales_pvp = useSelector(state => state.precios.decimales_pvp)
  const decimales_significativos = useSelector(state => state.precios.decimales_significativos)
  const locale = useSelector(state => state.precios.locale)
  const auth = useSelector(state => state.auth)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const pedido = useSelector(state => state.pedidos.pedido)
  const prevProps = useRef()

  useEffect(() => {
    // Comprobamos si el precio es para la ficha, y si lo es lo volvemos a pedir (para garantizar la mayor fiabilidad posible)
    if (
      props?.codigo_articulo &&
      (props?.origen === 'ficha' || props?.origen === 'carrito') &&
      precio[props.codigo_articulo] === undefined
    ) {
      if (props.codigo_articulo) {
        dispatch(getPrecio(props.codigo_articulo, 1, pedido.domicilio_envio, 'UN'))
      }
    }
    prevProps.current = {
      portal,
      precio,
      locale,
      auth,
      id_pedido_seleccionado,
      pedido,
    }
    prevProps.current.codigo_articulo = props.codigo_articulo
  }, [])

  useEffect(() => {
    if (
      props?.codigo_articulo &&
      (props?.origen === 'ficha' || props?.origen === 'carrito') &&
      precio[props.codigo_articulo] === undefined &&
      prevProps.current.codigo_articulo !== props.codigo_articulo
    ) {
      if (props.codigo_articulo) {
        dispatch(getPrecio(props.codigo_articulo, 1, pedido.domicilio_envio, 'UN'))
      }
    }
    prevProps.current = {
      portal,
      precio,
      locale,
      auth,
      id_pedido_seleccionado,
      pedido,
    }
    prevProps.current.codigo_articulo = props.codigo_articulo
  }, [props.codigo_articulo])

  const mostrarPresentacion = () => {
    return <>{precio?.[props.codigo_articulo]?.['UN'] && props.mostrar_pres !== 'N' ? '/UN' : ''}</>
  }

  const mostrarImpuestos = () => {
    return (
      <>
        {!Array.isArray(precio[props.codigo_articulo]) &&
        precio[props.codigo_articulo]['UN'].impuesto_articulo !== null &&
        props.mostrar_iva !== 'N'
          ? ' + ' + precio[props.codigo_articulo]['UN'].impuesto_articulo + '% IVA'
          : ''}
      </>
    )
  }

  const obtenerImpuesto = () => {
    if (precio?.[props.codigo_articulo]?.['UN']?.impuesto_articulo) {
      let impuesto = Number.parseFloat(
        precio[props.codigo_articulo]['UN'].impuesto_articulo,
      ).toFixed(decimales_pvp)
      return <span className='etiqueta-impuesto'>{impuesto.toString() + '%'}</span>
    } else {
      return ''
    }
  }

  const obtenerPrecio = precioSeleccionado => {
    let divisaPrecio = precio?.[props.codigo_articulo]?.['UN']?.divisa_precio ?? 'EUR'
    if (precioSeleccionado === 0) return
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: divisaPrecio,
    }).format(Number.parseFloat(precioSeleccionado).toFixed(decimales_pvp))
  }

  const obtenerPrecioBruto = () => {
    if (props.estilo_precio === 'unitario') {
      let precioPresentacion = precio[props.codigo_articulo]['UN'].precio_presentacion ?? ''
      return (
        <span className='etiqueta-precio-bruto'>
          {precioPresentacion ? obtenerPrecio(precioPresentacion) : ''}
          {mostrarImpuestos()}
          {mostrarPresentacion()}
          {props.añadir_descuento &&
          props.añadir_descuento !== 'null' &&
          props.añadir_descuento !== 'N'
            ? obtenerDescuento()
            : ''}
        </span>
      )
    } else {
      let importeBruto = precio[props.codigo_articulo]['UN'].importe_bruto ?? ''
      return (
        <span className='etiqueta-precio-bruto'>
          {importeBruto ? obtenerPrecio(importeBruto) : ''}
          {mostrarImpuestos()}
          {mostrarPresentacion()}
          {props.añadir_descuento &&
          props.añadir_descuento !== 'null' &&
          props.añadir_descuento !== 'N'
            ? obtenerDescuento()
            : ''}
        </span>
      )
    }
  }

  const obtenerDescuento = () => {
    let descuentoFinal = precio[props.codigo_articulo]['UN'].dto_4 ?? ''

    if (Number.parseFloat(descuentoFinal).toFixed(decimales_significativos) > 1) {
      if (
        props.añadir_descuento &&
        props.añadir_descuento !== 'null' &&
        props.añadir_descuento !== 'N'
      ) {
        return ' -' + Number(descuentoFinal).toFixed(decimales_pvp).toString() + '%'
      } else {
        return (
          <span className='etiqueta-descuento'>
            {Number(descuentoFinal).toFixed(decimales_pvp).toString() + '%'}
          </span>
        )
      }
    } else {
      return ''
    }
  }

  const obtenerPrecioUnidad = (precio, texto) => {
    if (precio === 0) return <></>
    else
      return (
        <span className='etiqueta-precio mixto'>
          {obtenerPrecio(precio)}
          {mostrarImpuestos()}
          {mostrarPresentacion()}
          {props.tipo_precio === 'unidad_sin_iva' ? (
            <span className='etiqueta-precio mixto precio-pers-unitario'>{texto}</span>
          ) : (
            <></>
          )}
        </span>
      )
  }

  const obtenerPrecioManual = () => {
    return (
      <span className='etiqueta-precio manual'>
        {obtenerPrecio(props.precio_manual)}
        {mostrarPresentacion()}
      </span>
    )
  }

  const obtenerPrecioMixto = () => {
    if (props.estilo_precio === 'unitario') {
      let importeNetoLin = precio[props.codigo_articulo]['UN'].imp_neto_lin ?? ''
      let precioPresentacion = precio[props.codigo_articulo]['UN'].precio_presentacion ?? ''
      if (
        auth?.user?.netear_precio &&
        auth.user.netear_precio !== 'N' &&
        Number.parseFloat(precioPresentacion).toFixed(decimales_pvp) !==
          Number.parseFloat(importeNetoLin).toFixed(decimales_pvp)
      ) {
        alert('UNIT')
        return (
          <Fragment>
            <span className='etiqueta-precio-tachado mixto'>
              {precioPresentacion ? obtenerPrecio(precioPresentacion) : ''}
              {mostrarImpuestos()}
              {mostrarPresentacion()}
            </span>
            <span className='etiqueta-precio mixto'>
              {importeNetoLin ? obtenerPrecio(importeNetoLin) : ''}
            </span>
          </Fragment>
        )
      } else {
        return (
          <Fragment>
            <span className='etiqueta-precio mixto'>
              {importeNetoLin ? obtenerPrecio(importeNetoLin) : ''}
              {mostrarImpuestos()}
              {mostrarPresentacion()}
            </span>
          </Fragment>
        )
      }
    } else {
      let importeBruto = precio[props.codigo_articulo]['UN'].imp_bruto_lin ?? ''
      let importeNeto = precio[props.codigo_articulo]['UN'].imp_neto_lin ?? ''

      if (
        auth?.user?.netear_precio &&
        auth.user.netear_precio !== 'N' &&
        Number.parseFloat(importeBruto).toFixed(decimales_pvp) !==
          Number.parseFloat(importeNeto).toFixed(decimales_pvp)
      ) {
        return (
          <Fragment>
            <span className='etiqueta-precio-tachado mixto'>
              {importeBruto ? obtenerPrecio(importeBruto) : ''}
              {mostrarImpuestos()}
              {mostrarPresentacion()}
            </span>
            <span className='etiqueta-precio mixto'>
              {importeNeto ? obtenerPrecio(importeNeto) : ''}
            </span>
          </Fragment>
        )
      } else {
        return (
          <Fragment>
            <span className='etiqueta-precio mixto'>
              {precio[props.codigo_articulo][props.presentacion].imp_neto_lin
                ? new Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: precio[props.codigo_articulo][props.presentacion].divisa_precio,
                  }).format(
                    Number.parseFloat(
                      precio[props.codigo_articulo][props.presentacion].imp_neto_lin,
                    ).toFixed(2),
                  )
                : ''}

              {mostrarImpuestos()}

              {mostrarPresentacion()}
            </span>
          </Fragment>
        )
      }
    }
  }

  // Precio cargando retornamos spinner
  if (auth?.user?.ver_precios === 'S') {
    if (props.precio_manual) {
      return obtenerPrecioManual()
    } else if (
      !precio?.[props.codigo_articulo]?.['UN'] ||
      precio?.[props.codigo_articulo]?.['UN']?.status === 'fetching'
    ) {
      return <Spinner showSpinner={true} />
    } else if (precio?.[props.codigo_articulo]?.['UN']?.status === 'error') {
      // Error retornamos mensaje
      return (
        <Fragment>
          <span className='etiqueta-precio no-disp'>{i18n.t('general.precnodi')}</span>
        </Fragment>
      )
    } else if (precio?.[props.codigo_articulo]?.['UN']) {
      // En cualquier otro caso retornamos lo que se nos indique en el prop tipo precio

      let precioSeleccionado
      let textoComplementario = ''
      let preciosArticulo = precio[props.codigo_articulo]['UN']
      if (props.tipo_precio && props.tipo_precio !== '') {
        switch (props.tipo_precio) {
          case 'un_con_iva':
            precioSeleccionado =
              preciosArticulo.importe_neto_unidad + preciosArticulo.importe_impuestos_ud
            textoComplementario = 'Con IVA (' + preciosArticulo.impuesto_articulo + '%)'
            break
          case 'un_sin_iva':
            precioSeleccionado = preciosArticulo.importe_neto_unidad
            textoComplementario = 'Sin IVA (' + preciosArticulo.impuesto_articulo + '%)'
            break
          default:
        }
      }

      return (
        <Fragment>
          <meta
            itemProp='priceCurrency'
            content={preciosArticulo.divisa_precio}
          />
          <meta
            itemProp='price'
            content={Number.parseFloat(preciosArticulo.imp_neto_lin).toFixed(decimales_pvp)}
          />

          {props.tipo_precio && props.tipo_precio !== ''
            ? props.tipo_precio === 'un_con_iva' || props.tipo_precio === 'un_sin_iva'
              ? obtenerPrecioUnidad(precioSeleccionado, textoComplementario)
              : props.tipo_precio === 'descuento'
                ? obtenerDescuento()
                : props.tipo_precio === 'mixto'
                  ? obtenerPrecioMixto()
                  : props.tipo_precio === 'bruto'
                    ? obtenerPrecioBruto()
                    : props.tipo_precio === 'impuesto'
                      ? obtenerImpuesto()
                      : obtenerPrecioMixto()
            : obtenerPrecioMixto()}
        </Fragment>
      )
    }
  }
}

export default Precio
